export enum SecondaryContentLocation {
  Above = 1,
  Below = 2,
}
